import { Award, TrendingUp, Layers, Briefcase, Handshake, LineChart } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Reveal, Eyebrow } from "./Reveal";

const ICONS = [Award, TrendingUp, Layers, Briefcase, Handshake, LineChart];

export const Why = () => {
  const { t } = useLang();
  const w = t.why;
  return (
    <section id="why" data-testid="why-section" className="relative mx-3 overflow-hidden rounded-[32px] border border-white/10 bg-[#0B1224] py-24 text-white sm:mx-6 sm:rounded-[48px] lg:py-32">
      <div className="pointer-events-none absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full bg-[#2F7BFF]/20 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="max-w-3xl">
          <Eyebrow light>{w.eyebrow}</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-[44px] lg:leading-[1.1]">{w.title}</h2>
          <p className="mt-6 text-base leading-relaxed text-white/70 sm:text-lg">{w.p}</p>
        </Reveal>
        <div className="mt-16 grid gap-px overflow-hidden rounded-3xl bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
          {w.items.map((it, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={it.t} delay={i * 80} className="h-full">
                <div data-testid={`why-item-${i}`} className="group h-full bg-[#0B1224] p-8 transition-colors duration-300 hover:bg-[#101B36] lg:p-10">
                  <div className="flex items-center justify-between">
                    <span className="grid h-12 w-12 place-items-center rounded-xl bg-[#2F7BFF] text-white transition-transform duration-300 group-hover:scale-110"><Icon className="h-6 w-6" /></span>
                    <span className="font-display text-sm font-bold text-white/25">0{i + 1}</span>
                  </div>
                  <h3 className="mt-7 font-display text-xl font-bold">{it.t}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-white/65">{it.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal><p data-testid="why-closing" className="mt-14 max-w-3xl font-display text-xl font-semibold leading-snug text-white sm:text-2xl">{w.closing}</p></Reveal>
      </div>
    </section>
  );
};
